import Vue from 'vue';
import LoadingMask from './LoadingMask.vue';

let instance;

function createInstance() {
	// 创建挂载节点（在 #app 外层，挂到 body 下）
	const container = document.createElement('div');
	document.body.appendChild(container);

	// 通过 Vue.extend 生成实例
	const MaskConstructor = Vue.extend(LoadingMask);
	const vm = new MaskConstructor().$mount(container);

	return vm;
}

export default {
	show() {
		if (!instance) {
			instance = createInstance();
		}
		instance.show();
	},
	hide() {
		if (instance) {
			instance.hide();
		}
	}
};
